import React, { useContext } from "react";
import { Form, Typography, Input, Collapse } from "antd";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import PastMedicalHistory from "./History/PastMedicalHistory";
import PastSurgicalHistory from "./History/PastSurgicalHistory";
import KnownAllergies from "./History/KnownAllergies";
import { UserContext } from "../../../../context/UserContext";

const HistoryIllness = ({ data, patientData, admissionMode }) => {
  const { userDetails } = useContext(UserContext);
  const patientFullName = `${patientData?.patient?.first_name || ""} ${
    patientData?.patient?.last_name || ""
  }`.trim();
  const isHomeAdmission = admissionMode === "home";

  const patientIntro = (
    <Typography.Text>
      Mr/Ms. {patientFullName || "—"}, {patientData?.patient?.age_by_dob} years
      old, {patientData?.patient?.gender}
      {isHomeAdmission ? " " : " was admitted in "}
    </Typography.Text>
  );

  const illnessField = (
    <Form.Item
      style={{ display: "inline-block" }}
      name={["history", "history_of_illness"]}
    >
      <Input
        className={inputStyles.mdInput}
        style={{ width: "250px" }}
        placeholder="History of present illness"
      />
    </Form.Item>
  );

  return (
    <>
      {" "}
      <Typography>
        {isHomeAdmission ? (
          <>
            {patientIntro}
            <Typography.Text> with </Typography.Text>
            {illnessField}{" "}
            <Typography.Text>
              was admitted in {userDetails?.activeOrg?.org_name} for functional
              recovery.
            </Typography.Text>
          </>
        ) : (
          <>
            {patientIntro}
            <Form.Item
              style={{ display: "inline-block" }}
              name={["history", "hospital"]}
            >
              <Input
                className={inputStyles.mdInput}
                style={{ width: "250px" }}
                placeholder="Hospital"
              />
            </Form.Item>
            <Typography.Text> with </Typography.Text>
            {illnessField}{" "}
            <Typography.Text> and he underwent </Typography.Text>
            <Form.Item
              style={{ display: "inline-block" }}
              name={["history", "surgical_treatment"]}
            >
              <Input
                className={inputStyles.mdInput}
                style={{ width: "250px" }}
                placeholder="Surgical/Medical Treatment"
              />
            </Form.Item>{" "}
            <Typography.Text>
              Patient gradually recovered, but with some residual deficits and
              after discharge was admitted in {userDetails?.activeOrg?.org_name}{" "}
              for functional recovery.
            </Typography.Text>
          </>
        )}
      </Typography>
      <Collapse
        expandIconPosition="right"
        defaultActiveKey={["1", "2", "3", "4", "5"]}
      >
        <Collapse.Panel header="Past Medical History" key="1">
          <PastMedicalHistory data={data} />
        </Collapse.Panel>
        <Collapse.Panel header="Past Surgical History" key="2">
          <PastSurgicalHistory data={data} />
        </Collapse.Panel>
        <Collapse.Panel header="Known Allergies" key="3">
          <KnownAllergies data={data} />
        </Collapse.Panel>
      </Collapse>
    </>
  );
};

export default HistoryIllness;
